import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './wdyr'

import React from 'react'

import { init } from '@pb/utils'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import smoothscroll from 'smoothscroll-polyfill'

import App from './App'
import setupNetworkInterceptors from './helpers/axiosSetup'
import googleTranslateFix from './helpers/googleTranslateFix'
import HmOptimizelyProvider from './helpers/HmOptimizelyProvider'
import configureStore from './redux/configure-store'
import '@pb/components/dist/esm/assets/scss/_defaults.scss'

declare global {
  // Using a var is required here, see https://github.com/microsoft/TypeScript/issues/30139#issuecomment-939517597 for more information
  // eslint-disable-next-line @typescript-eslint/naming-convention, vars-on-top, no-var
  var hm_react_version: string
}
global.hm_react_version = `${process.env.VERSION}-${process.env.ENVIRONMENT}`

smoothscroll.polyfill()

googleTranslateFix()

const store = configureStore({})
setupNetworkInterceptors(store)

let renderApp: Function
const appData = (
  <Provider store={store}>
    <HmOptimizelyProvider>
      <App />
    </HmOptimizelyProvider>
  </Provider>
)
const appId = document.getElementById('app')

if (process.env.IS_FORMATTERS_API_ENABLED !== 'enabled') {
  renderApp = (): void => {
    ReactDOM.render(appData, appId)
  }
} else {
  renderApp = async (): Promise<void> => {
    await init()
    ReactDOM.render(appData, appId)
  }
}

renderApp()
